import React, { useState, useEffect } from 'react';
import { get } from '@api/v4/resources/metadata_conversions';

import Table from './table';
import Form from './form';

import './styles/metadata_conversions';

const MetadataConversions = () => {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState('');
  const [editableKey, setEditableKey] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const isCollection = Boolean(BF.fx.collection().key);
  const resourceType = isCollection ? 'collection' : 'brandfolder';
  const resourceFunc = isCollection ? BF.fx.collection : BF.fx.brandfolder;
  const { key } = resourceFunc();

  const refreshData = async () => {
    const metadataCustomFields = await get({
      resourceType,
      resourceKey: key,
    });
    const sortedMetadataConversions = metadataCustomFields.sort((a, b) => (
      (a.metadata_term.toLowerCase() < b.metadata_term.toLowerCase()) ? -1 : 1));

    setItems(sortedMetadataConversions);
  };

  useEffect(() => {
    refreshData();
  }, []);

  const filteredItems = items.filter(({ metadata_term, key_term }) => (
    metadata_term && metadata_term.toLowerCase().includes(search.toLowerCase()))
    || (key_term && key_term.toLowerCase().includes(search.toLowerCase())));

  const selectedItem = items.filter(({ id }) => id === editableKey)[0];

  const renderForm = () => (
    <Form
      refreshData={refreshData}
      resourceType={resourceType}
      resourceKey={key}
      selectedItem={selectedItem}
      editableKey={editableKey}
      setEditableKey={setEditableKey}
      setShowForm={setShowForm}
    />
  );

  const renderTable = () => (
    <>
      <input
        type="text"
        className="brandfolder-input searchbar"
        value={search}
        onChange={({ target }) => setSearch(target.value)}
        placeholder={t("Search")}
      />

      <Table
        items={filteredItems}
        refreshData={refreshData}
        setEditableKey={setEditableKey}
        setShowForm={setShowForm}
      />
    </>
  );
  return (
    <div className="metadata_conversions">
      <div className="header">
        <h2>{t("Metadata Conversions")}</h2>
        { !showForm && (
          <button
            type="button"
            className="button primary"
            onClick={() => setShowForm(!showForm)}
          >
            <span className="bff-plus" style={{ marginRight: "10px" }} />
            {t("Create New")}
          </button>
        )}
      </div>
      <hr />
      { !showForm && (
        <div className="description">
          <p className="first">{t("Generate Custom Fields or Tags based on embedded metadata from each assets' first attachment.")}</p>
          <p>{t("This conversion will not apply to existing assets, but will apply to assets uploaded after the conversion is created.")}</p>
          <p className="last">{t("To retroactively apply conversions, click the \"Apply\" button.")}</p>
        </div>
      )}
      { showForm ? renderForm() : renderTable() }
    </div>
  );
};

export default MetadataConversions;
